import MembershipListWrap from './MembershipListWrap';
export default MembershipListWrap;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipList/index.ts